export default "__VITE_ASSET__DQR1Hd0g__"